export default {"src":"/_next/static/media/no-payments-logo.4c467b5c.svg","height":206,"width":206,"blurWidth":0,"blurHeight":0};